module.exports = __webpack_public_path__ + "img/germany.c37d8540.svg";